import Image from "next/image";
import withWindowDimensions from "../shared/withWindowDimensions";

const TestimonialCard = ({
  image,
  mobileImage,
  name,
  city,
  story,
  college,
  collegeCity,
  windowWidth,
  isMobileSized,
}) => {
  const getImage = () => {
    if (windowWidth < 767) {
      return mobileImage;
    } else {
      return image;
    }
  };
  return (
    <div className="bg-gray2-700 relative min-h-[400px] md:min-h-390">
      <div className="absolute bottom-0 right-0  w-full h-auto bg-[#ebebeb] flex justify-end">
        <Image
          src={getImage()}
          alt={name}
          width={isMobileSized ? 191.09 : 242.55}
          height={isMobileSized ? 180.29 : 223.33}
          className="max-w-full h-auto"
        />
        <div className="absolute bottom-5 left-[-20px] bg-white before:absolute before:bottom-full before:left-0 before:h-0 before:w-0 before:border-b-[10px] before:border-b-[#9e9e9e] before:border-l-[20px] before:border-l-transparent">
          <p className="text-[#1B1D6A] text-[14px] md:text-[18px] font-semibold md:font-bold px-3 md:px-6 py-2 leading-none">
            {college} <br />
            <span className="text-primary text-[12px] md:text-[14px]">
              {collegeCity}
            </span>
            </p>
        </div>
      </div>
      <div className="text-blue-950 py-4 md:py-6 px-4 md:pl-5 w-full absolute">
        <p className="text-2xl pb-3">
          <strong>{name} </strong>{" "}
          <span className="md:text-primary">| {city}</span>
        </p>
        <p className="text-sm md:text-base lg:text-md pb-4">{story}</p>
      </div>
    </div>
  );
};

export default withWindowDimensions(TestimonialCard);
